module.exports = __webpack_public_path__ + "img/2.eb9a5105.jpg";